import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';


import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';


import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import Breadcrumbs from '@mui/material/Breadcrumbs';



import AddTransporteurCompteDialog from './AddTransporteurCompteDialog';
import DeleteTransporteurCompteDialog from './DeleteTransporteurCompteDialog';



const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },

    administrationHeaderContainer: {
        display: 'flex',
        width: '100%'
    },
    administrationHeaderItemLeft: {
        flex: '1 1 auto'
    },
    administrationHeaderItemRight: {
        flex: '0 1 auto'
    },
           


    table: {
        minWidth: 700
    },

    link: theme.style.link, 

    deleting: {
        background: 'red'
    },


    cellDepots: {
        display: 'flex',
        flexDirection: 'column'
    }
});



class AdministrationTransporteurComptes extends React.Component {
          

    render() {
        let { classes, selectedTransporteur,
            onOpenAddDialog, onCloseAddDialog,
            onOpenDeleteDialog, onCloseDeleteDialog,

            addTransporteurCompteDialogOpen, addTransporteurCompte, deleteTransporteurCompteDialogOpen, deleteTransporteurCompte, transporteurCompteToDelete,

            setDefautTransporteurCompte,

            depotsGestion

        } = this.props;
        
        let sortedComptes = [];
        if (selectedTransporteur) {
            sortedComptes = selectedTransporteur.comptes.sort((a, b) => a.defaut ? -1 : b.defaut ? 1 : !a.depotsGestion || !a.depotsGestion.length ? -1 : !b.depotsGestion || !b.depotsGestion.length ? 1 : a.depotsGestion[0].codeDepot > b.depotsGestion[0].codeDepot ? 1 : 0);
        }


        return (
            <React.Fragment>

                {!selectedTransporteur && '404'} {/* Voir comment on peut rediriger vers une 404 proprement*/}
                
                {addTransporteurCompteDialogOpen && <AddTransporteurCompteDialog onClose={onCloseAddDialog} onClickSave={addTransporteurCompte} transporteur={selectedTransporteur} depotsGestion={depotsGestion} />}
                {deleteTransporteurCompteDialogOpen && <DeleteTransporteurCompteDialog onClose={onCloseDeleteDialog} onClickDelete={deleteTransporteurCompte} transporteur={selectedTransporteur} transporteurCompte={transporteurCompteToDelete} />}

                {selectedTransporteur && (
                    <div className={classes.root}>

                        <Helmet>
                            <title>{`Comptes du transporteur : ${selectedTransporteur.code}`}</title>
                        </Helmet>
                        

                        <div className={classes.administrationHeaderContainer}>
                            <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                                Édition des comptes du transporteur : {selectedTransporteur.code}
                            </Typography>
                            <Button className={classes.administrationHeaderItemRight} onClick={onOpenAddDialog}>Nouveau</Button>
                        </div>



                        <Breadcrumbs separator="›" arial-label="breadcrumb">
                            <Link to={`/administration/transporteurs/`} className={classes.link}>
                                <Typography variant="button">
                                    Transporteurs
                                </Typography>
                            </Link>
                            <Link to={`/administration/transporteurs/${selectedTransporteur.id}`} className={classes.link}>
                                <Typography variant="button">
                                    {selectedTransporteur.code}
                                </Typography>
                            </Link>

                            <Typography color="textPrimary">Comptes</Typography>
                        </Breadcrumbs>

                        

                        <Paper className={classes.root}>

                            <Table className={classes.table} size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='right'>Id</TableCell>
                                        <TableCell>Compte</TableCell>
                                        <TableCell>Login</TableCell>
                                        <TableCell>Mot passe</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Dépôt(s)</TableCell>
                                        <TableCell>Défaut</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortedComptes.map((compte, index) => {
                                        return (
                                            <TableRow
                                                key={compte.id}
                                                className={transporteurCompteToDelete && transporteurCompteToDelete.id === compte.id ? classes.deleting : ''}
                                                hover
                                            >
                                                <TableCell component="th" scope="row" align='right'>
                                                    <Link to={`/administration/transporteurs/${selectedTransporteur.id}/comptes/${compte.id}`} className={classes.link}>
                                                        <Typography variant="button">
                                                            {compte.id}
                                                        </Typography>
                                                    </Link>
                                                </TableCell>
                                                <TableCell>{compte.compte}</TableCell>
                                                <TableCell>{compte.login}</TableCell>
                                                <TableCell>{compte.motPasse}</TableCell>
                                                <TableCell>{compte.email}</TableCell>
                                                <TableCell>
                                                    <span className={classes.cellDepots}>
                                                        {compte.depotsGestion.map((x, i) => (<span key={i}>
                                                            {x.codeDepot} - {x.nom}
                                                        </span>
                                                        ))}
                                                    </span>
                                                </TableCell>
                                                <TableCell>{compte.defaut ? 'Oui' : 'Non'}</TableCell>
                                                <TableCell>
                                                    <Button disabled={compte.defaut} onClick={e => onOpenDeleteDialog(compte.id)}>Supprimer</Button>
                                                    <Button disabled={compte.defaut} onClick={e => setDefautTransporteurCompte(compte.id)}>Défaut</Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>    

                        </Paper>

                        
                    </div>
                )}


            </React.Fragment>


        );
    }
}

AdministrationTransporteurComptes.propTypes = {
    classes: PropTypes.object.isRequired,

    isPatching: PropTypes.bool.isRequired,
    selectedTransporteur: PropTypes.object
};

export default withStyles(styles)(AdministrationTransporteurComptes);